import { Content, Container } from "./styled";

const Onas = () => (
    <Container>
        <Content>
            Firma „KURIER” s.c. Jankowscy istnieje od 1999r. Naszą główną działalnością
            jest wynajem autokarów i busów. W początkowej fazie rozwoju firma posiadała 2
            autokary i realizowała kilka regularnych połączeń na trasie Mońki – Białystok –
            Mońki. Jednak z biegiem lat, dzięki dynamicznemu rozwojowi firmy dziś możemy
            zaproponować Państwu szeroki zakres usług turystycznych. Nasz tabor znacznie
            powiększył się i w swojej ofercie mamy autokary i busy z różną ilością miejsc
            do przewozu małych i większych grup. Posiadamy wszelkie niezbędne licencje i
            zezwolenia na poruszanie się po kraju i w ruchu międzynarodowym a w
            szczególności zezwolenia na Niemcy. Obsługujemy biura podróży, firmy, szkoły,
            imprezy okolicznościowe i inne.<br></br>
            <br></br>
            Realizujemy połączenia na regularnej linii autobusowej na trasie Białystok –
            Mońki – Białystok przez Knyszyn.<br></br>
            <br></br>
            Zajmujemy się również sprzedażą biletów lotniczych, autokarowych oraz
            promowych. Sprzedajemy wycieczki krajowe i zagraniczne oraz kolonie dla dzieci
            i młodzieży. Przygotowujemy wycieczki dla grup zorganizowanych.<br></br>
            <br></br>
            Zapewniamy naszym klientom najwyższą jakość świadczonych usług. Do
            każdego klienta podchodzimy indywidualnie starając się dopasować usługę w
            zależności od potrzeb zamawiającego.
        </Content>
    </Container>
);

export default Onas;